import React, { useState } from "react";
import api from "../api";
import { CONNECT_GITHUB, ENABLE_CHECKS, MANAGE_ACCESS } from "../copy/setupCopy";

function isAllowedGitHubUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "https:" && parsed.hostname === "github.com" && parsed.pathname.startsWith("/apps/");
  } catch {
    return false;
  }
}

export default function GitHubConnectionCard({ setup, canConnect, manageUrl }) {
  const [error, setError] = useState("");
  const [pending, setPending] = useState(false);
  const connected = setup?.installationState === "active";
  const needsChecks = connected && setup?.checksWrite === false;

  async function connect() {
    const tab = window.open("", "_blank");
    setError("");
    setPending(true);
    try {
      const response = await api.get("/github-app/install-url");
      const url = response?.data?.installUrl;
      if (url && isAllowedGitHubUrl(url) && tab) {
        tab.location.href = url;
        return;
      }
      tab?.close?.();
      setError(tab ? "GitHub connection is not available right now." : "GitHub was blocked by the browser. Allow pop-ups for this site, then try again.");
    } catch {
      tab?.close?.();
      setError("GitHub connection is not available right now.");
    } finally {
      setPending(false);
    }
  }

  return (
    <section className="rr-card">
      <p className="rr-kicker">GitHub</p>
      <h2>{connected ? "GitHub is connected" : "Connect GitHub"}</h2>
      <p>
        {connected
          ? "This workspace has an active RenderRepo GitHub App installation."
          : "Connecting GitHub lets RenderRepo publish a check on the pull request. Public pull requests can still be reviewed before that."}
      </p>
      {canConnect && (!connected || needsChecks) ? (
        <button type="button" id="github-connect" className="rr-button secondary" onClick={connect} disabled={pending}>
          {pending ? "Opening GitHub…" : needsChecks ? ENABLE_CHECKS : CONNECT_GITHUB}
        </button>
      ) : null}
      {canConnect && manageUrl ? (
        <p>
          <a href={manageUrl} target="_blank" rel="noreferrer">
            {MANAGE_ACCESS}
          </a>
        </p>
      ) : null}
      {error ? <p role="alert">{error}</p> : null}
    </section>
  );
}
